var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.135,
    height: 26.147,
    viewBox: "0 0 35.135 26.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-logo-youtube",
    "data-name": "Icon ionic-logo-youtube",
    d: "M34.906,10.274a5.31,5.31,0,0,0-5.079-5.529c-3.8-.177-7.68-.245-11.64-.245H16.952c-3.953,0-7.838.068-11.64.245A5.321,5.321,0,0,0,.24,10.287C.069,12.711-.007,15.135,0,17.559s.069,4.848.233,7.278a5.328,5.328,0,0,0,5.072,5.549c3.994.184,8.092.266,12.258.259q6.259.02,12.258-.259A5.329,5.329,0,0,0,34.9,24.838c.165-2.431.24-4.855.233-7.285Q35.153,13.916,34.906,10.274Zm-20.7,13.965V10.859l9.952,6.686Z",
    transform: "translate(0 -4.5)",
    fill: "#E6E7EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeGrey);
export default __webpack_public_path__ + "static/media/YoutubeGrey.0463100edd59e9fe4881e5b722454e58.svg";
export { ForwardRef as ReactComponent };